export function createPortal() {
  var portal = document.createElement('div');
  portal.setAttribute('data-active-modal', '');
  document.body.appendChild(portal);
  addAriaHiddenAndDisablePrint(portal);
  if (portals.indexOf(portal) === -1) {
    portals.push(portal);
  }
  return portal;
}
var portals = [];
export function destroyPortal(portal) {
  if (portals.length === 1) {
    removeAllVisibilityRestrictions(portal);
  } else {
    removeTopVisibilityRestrictions(portal);
  }
  document.body.removeChild(portal);
  var portalIndex = portals.indexOf(portal);
  portals.splice(portalIndex, 1);
}
export var noPrintClassName = 'citrix-ui-no-print';
function addAriaHiddenAndDisablePrint(portal) {
  var _portal$parentNode;
  var node = (_portal$parentNode = portal.parentNode) === null || _portal$parentNode === void 0 ? void 0 : _portal$parentNode.firstChild;
  while (node) {
    if (node.nodeType === Node.ELEMENT_NODE && node !== portal) {
      node.setAttribute('aria-hidden', 'true');
      node.classList.add(noPrintClassName);
    }
    node = node.nextSibling;
  }
}
function removeAllVisibilityRestrictions(portal) {
  var _portal$parentNode2;
  var node = (_portal$parentNode2 = portal.parentNode) === null || _portal$parentNode2 === void 0 ? void 0 : _portal$parentNode2.firstChild;
  while (node) {
    if (node.nodeType === Node.ELEMENT_NODE && node !== portal) {
      node.setAttribute('aria-hidden', 'false');
      node.classList.remove(noPrintClassName);
    }
    node = node.nextSibling;
  }
}
function removeTopVisibilityRestrictions(portal) {
  var _portal$parentNode3;
  var node = (_portal$parentNode3 = portal.parentNode) === null || _portal$parentNode3 === void 0 ? void 0 : _portal$parentNode3.lastChild;
  while (node) {
    if (node.nodeType === Node.ELEMENT_NODE && node !== portal && node.hasAttribute('data-active-modal')) {
      node.setAttribute('aria-hidden', 'false');
      node.classList.remove(noPrintClassName);
      break;
    }
    node = node.previousSibling;
  }
}